export default "__VITE_ASSET__6b77dba3__"